import type { StateCreator } from 'zustand';

import type { CartExperimentState } from '@/types/cart-experiment';

export interface CartExperimentSlice {
  cartExperiment: CartExperimentState;
  /** 仅供实验解析层提交；消费者通过 resolver 的 reset 失效，避免旧请求回写。 */
  setCartExperimentState: (state: CartExperimentState) => void;
}

/** 每个 App Store 拥有独立状态；不请求、不持久化，也不依赖领域运行时代码。 */
export const createCartExperimentSlice: StateCreator<CartExperimentSlice> = (set) => ({
  cartExperiment: { status: 'idle' },
  setCartExperimentState: (cartExperiment) => set({ cartExperiment }),
});
